/**
 * PHA-1048: which organization's "Voice of patient intake" flag applies to the care plan
 * on screen.
 *
 * The patient chart (`PatientDetail`) has always answered this with the PATIENT's org.
 * The onboarding/refresh wizard answered it with the ORG SWITCHER's current selection,
 * which is `undefined` whenever the switcher sits on "All clinics" — a common default for
 * anyone covering more than one clinic. The flag then resolved from the BFF session's
 * `current_organization_id`, which the switcher does not reliably set (the PHA-904 failure
 * mode), so it came back false.
 *
 * The visible result: the same patient's care plan renders its Voice-of-the-Patient
 * section on the chart and drops it in the wizard and the draft PDF — along with the Full
 * Problem List and Full Medication List, which PHA-865 gates on the same flag. From the
 * clinician's side that reads as "regenerating the care plan loses the VoP questions".
 *
 * The patient's own org wins whenever a patient is loaded, which is always true in the
 * care-plan refresh flow. The switcher is the fallback for a brand-new patient who does
 * not exist yet.
 */
export function resolveVoiceOfPatientOrgId(
  patientOrgId: string | null | undefined,
  switcherOrgId: string | null | undefined
): string | undefined {
  const fromPatient = (patientOrgId ?? '').toString().trim();
  if (fromPatient) return fromPatient;
  const fromSwitcher = (switcherOrgId ?? '').toString().trim();
  return fromSwitcher || undefined;
}
